import {call,put,takeEvery,take} from 'redux-saga/effects';
import axios from 'axios';
import {setCookie,getCookie} from '../../Components/HelperFunctions/CookieSettings'
import ApiData from './ApiData.json';

function searchStudentAPI(action)
{
    const requestBody = action.payload ;
    let http = `${ApiData.BaseApiLink}/Teacher/SearchStudent`;
    
    return axios.post(http,requestBody,
    { headers:{Authorization:'Bearer '+getCookie('domockexamToken'),"Content-Type":"application/json"}})
    .then((res)=>{
        console.log("Successfully searched student ")
        return res.data;
    })
    .catch((err)=>{
        console.log('err-searchStudentAPI:',err);
    })
}

function* searchStudentAPIWorkerSaga(action)
{
    try{
            const Result = yield call(searchStudentAPI,action);
            console.log('searched',Result);
            yield put({type:'SEARCH_STUDENT',payload:Result})
    }
    catch(e)
    {

    }
}

export function* searchStudentAPISaga()
{
    yield takeEvery('SEARCH_STUDENT_REQUESTED',searchStudentAPIWorkerSaga)
}